<template>
    <div class="home-page" style="padding-top: 20px;">

		  <div class="">
		    <a class="logo" href="/"><img src="static/images/logo.png" /></a>
		  </div>
		<div class="home-content mt20">
      <div class="content crfff ac por">
       <div class="fs50" v-html="$t('indexTips1')"></div>
<!--        <div class="fs26 mt30 cr44ffd0">{{$t('indexTips2')}} :</div>-->

        <div class="ac disflex mt50" style="justify-content: space-evenly;padding:0 6%">
          <div style="width: 45%;"  @click="getTypeLogin('daily')">
            <button class="button fw7" style="background:linear-gradient(90deg,#de047f, #fe65bf);width: 100%;">{{$t('Daily')}}</button>
          </div>
          <div style="width: 45%;" @click="getTypeLogin('weekly')">
            <button style="background:linear-gradient(90deg,#5e96fc, #44ffd0);width: 100%;" class="button fw7">{{$t('Weekly')}}</button>
          </div>
        </div>
        <div class="mt50">
          <div class="land-content al">
<!--            <div  class="two" @click="getChange(9)" >
              <div class="fs36">{{$t('BgFusion')}}</div>
              <img src="../../static/images/Smart_Blend.png" />
              <div class="disflex">
                <span class="fs26">{{$t('BgFusion_tips2')}}</span>
                <button class="button mt30 crfff" >
                  {{$t('letgo')}}<img src="../../static/images/go.png" />
                </button>
              </div>
            </div>-->
            <div class="two" @click="getTypeLogin('daily')" >
              <div class="fs36">{{$t('sexTitle1')}}</div>
              <img src="../../static/images/land-img1.jpg" />
              <div class="disflex">
                <span class="fs26">{{$t('landfont1')}}</span>
                <button class="button mt30 crfff" >
                    {{$t('letgo')}}<img src="../../static/images/go.png" />
                </button>
              </div>
            </div>
<!--            <div class="two" @click="getChange(2)" >-->
<!--              <div class="fs36">{{$t('aiAnimeTitle')}}</div>-->
<!--              <img src="../../static/images/land-img2.png" />-->
<!--              <div class="disflex">-->
<!--                <span class="fs26">{{$t('landfont2')}}</span>-->
<!--                <button class="button mt30 crfff" >-->
<!--                    {{$t('letgo')}}<img src="../../static/images/go.png" />-->
<!--                </button>-->
<!--              </div>-->
<!--            </div>-->

            <div class="two" @click="getTypeLogin('daily')" >
              <div class="fs36">{{$t('GenerateImage')}}</div>
              <img src="../../static/images/land-img3.jpg" />
              <div class="disflex">
                <span class="fs26">{{$t('landfont3')}}</span>
                <button class="button mt30 crfff" >
                    {{$t('letgo')}}<img src="../../static/images/go.png" />
                </button>
              </div>
            </div>
<!--            <div class="two" @click="getChange(4)" >
              <div class="fs36">{{$t('petTitle1')}}</div>
              <img src="../../static/images/land-img4.jpg" />
              <div class="disflex">
                <span class="fs26">{{$t('landfont4')}}</span>
                <button class="button mt30 crfff" >
                    {{$t('letgo')}}<img src="../../static/images/go.png" />
                </button>
              </div>
            </div>-->
<!--            <div class="two" @click="getChange(5)" >
              <div class="fs36">{{$t('ImageRestorer')}}</div>
              <img src="../../static/images/land-img5.png" />
              <div class="disflex">
                <span class="fs26">{{$t('landfont5')}}</span>
                <button class="button mt30 crfff" >
                    {{$t('letgo')}}<img src="../../static/images/go.png" />
                </button>
              </div>
            </div>-->
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/Header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,Dialog
    },
    data() {
      return {
        info:{},
        isShow:null,
        isEN:'bur',
        score:'',
        mobile:'',
        type:'daily',
      }
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
    if (this.$route.query.msisdn){
      this.mobile = this.$route.query.msisdn
    }
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
	},
    methods: {
      getChange(type){
        let that = this
        this.isShow = type
        var channelId  = this.$route.query.channelId
        var tracker  = this.$route.query.tracker
        var code  = this.$route.query.code
        if(that.mobile==''){
          that.$router.push({path:'/login',query: {type:that.type,channelId:channelId,tracker:tracker,code:code}})
        }else{
          that.$router.push({path:'/purchaseChances2',query: {mobile:this.$route.query.msisdn,channelId:channelId,tracker:tracker,code:code}});
        }
      },
      getTypeLogin(type){
        this.type = type
        this.goLogin()
      },
      goLogin(){
        let that = this
        var channelId  = this.$route.query.channelId
        var tracker  = this.$route.query.tracker
        var code  = this.$route.query.code
        if(that.mobile==''){
          that.$router.push({path:'/login',query: {type:that.type,channelId:channelId,tracker:tracker,code:code}})
        }else{
          that.$parent.loadModal(true);
          var data = {
            mobile: that.mobile,
            type:that.type,
            channelId:channelId,
            tracker:tracker,
            code:code
          }
          that.$api.post('/api/user/sub',data,r =>{
            that.$parent.loadModal(false);
            if (r.code == 1){
              that.$parent.returnCode(r,function(){
                localStorage.setItem('token',r.data.userinfo.token)
                localStorage.setItem('mobile',r.data.userinfo.mobile)
                that.$router.push('/');
              });
            }else{
              that.$utils.alertText(r.msg,100, 3000);
            }
          })
        }
      }
	}
}
</script>
<style scoped>
  .close{
    background: rgb(255 255 255 / 20%);
    color: #fff;
    width: 100px;
    height: 100px;
    font-size: 60px;
    margin: 30px auto 0;
    border-radius: 100px;
  }
  .new-img{margin: 40px 40px 0;width: auto;}
  .new-img .img-b{width: 48%;border: 4px solid #0062ff;
    border-radius: 10px;}
  .img-b img{width: 100%;border-radius: 10px;}
</style>



// WEBPACK FOOTER //
// src/page/land_v2.vue